<template>
    <div class="page">
        <el-form v-if="send" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
            <el-form-item label="">
                <el-input placeholder="岗位名称" v-model="queryForm.postName"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="checkState = 'check'">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="checkState = 'reset'">重置</el-button>
            </el-form-item>
        </el-form>
        <PostListTable :data="this.data" @send="getData" :queryForm="queryForm" :checkState="checkState" @resetCheckState="resetCheckState"></PostListTable>
    </div>
</template>

<script>
import PostListTable from '@/components/organization/PostListTable.vue';

export default {
    components: {
        PostListTable
    },
    data() {
        return {
            queryForm: {
                postName: ''
            },
            send: '',
            data: '',
            checkState: ''
        };
    },
    methods: {
        getData(data){
            this.send=data;
        },
        resetCheckState() {
            if (this.checkState == 'reset') {
                this.queryForm = {
                    postName: ''
                };
            }
            this.checkState = '';
        }
    }
};
</script>

<style lang="scss" scoped></style>
